/**
 * author       : zwl
 * createTime   : 2018/6/28 下午5:08
 * description  :
 */
import api from 'util/axios'

export function getPageInfo (appId) {
  return api({
    method: 'get',
    url: '/page/' + appId
  })
}

export function updatePage (appId, params) {
  return api({
    method: 'put',
    url: '/page/' + appId,
    data: params
  })
}
